module.exports = __webpack_public_path__ + "assets/img/sjkf01.png";